import { render, staticRenderFns } from "./IconWorkStatus.vue?vue&type=template&id=5c900aba&"
import script from "./IconWorkStatus.vue?vue&type=script&lang=js&"
export * from "./IconWorkStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports